import classNames from "classnames"
import { IconButton } from "../IconButton"
import { LoadingSpinner } from "../LoadingSpinner"
import { Text } from "../Text"
import { Link } from "../Link"
import type { FileUploadItemProps } from "./types"

export function FileUploadItem({
  children,
  error,
  href,
  loadingLabel = "Uploading file",
  removeLabel = "Remove file",
  isLoading,
  onRemove,
}: FileUploadItemProps) {
  const _showRemoveButton = !isLoading && !error && onRemove
  const _className = classNames("px-5 text-gray-400", {
    "py-3": _showRemoveButton,
    "py-4": !_showRemoveButton,
    "bg-gray-100": error,
  })

  const renderLink = () => {
    return (
      <Link as="a" download={children} href={href}>
        {children}
      </Link>
    )
  }

  const shouldRenderLink = !isLoading && !error && href

  return (
    <li className={_className} aria-busy={isLoading}>
      <div className="flex items-center justify-between">
        {shouldRenderLink && renderLink()}
        {!shouldRenderLink && <Text className="truncate">{children}</Text>}
        {isLoading && (
          <div className="flex gap-2">
            <Text size="tiny">{loadingLabel}</Text>
            <LoadingSpinner />
          </div>
        )}
        {_showRemoveButton && (
          <IconButton
            aria-label={removeLabel}
            iconName="Trash"
            size="sm"
            type="button"
            variation="borderless"
            onClick={onRemove}
          />
        )}
      </div>
      {!!error && (
        <Text size="small" className="text-error-base">
          {error}
        </Text>
      )}
    </li>
  )
}

FileUploadItem.displayName = "FileUpload.Item"
